import type { ProductType } from '../types/product-type.enum';

/** Safe lookup for locale maps keyed by product-type codes (GO/IG/…). */
export function dictByType(
  map: Record<string, string> | undefined,
  type: ProductType | string | undefined,
): string {
  if (!map || type == null) return '';
  return map[type] ?? '';
}
